import { PubEvent, EventType } from "./Responses";
import { NewEventFromUserRequest, UpdateEventRequest } from "./Requests";

export default class CreateEventData {
    public eventName = "";
    public location = "";
    public startDateInternal: Date = new Date();
    public endDateInternal: Date = new Date();
    public description = "";
    public event: PubEvent | null = null;
    public endDateEnabled = false;
    public eType = EventType.private;
    public canceled = false;

    get startTime() {
        return this.startDateInternal.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        });
    }

    set startTime(val: string) {
        const parts = val.split(":").map((x) => Number(x));
        this.startDateInternal.setHours(parts[0], parts[1]);
    }

    get startDate(): string {
        return this.dateToISOString(this.startDateInternal);
    }

    set startDate(strDate: string) {
        let val = this.parseDateLocal(strDate);
        const h = this.startDateInternal.getHours();
        const m = this.startDateInternal.getMinutes();
        const s = this.startDateInternal.getSeconds();
        val.setHours(h, m, s);
        this.startDateInternal = val;
    }

    get endTime() {
        return this.endDateInternal.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        });
    }

    set endTime(val: string) {
        const parts = val.split(":").map((x) => Number(x));
        this.endDateInternal.setHours(parts[0], parts[1]);
    }

    get endDate(): string {
        return this.dateToISOString(this.endDateInternal);
    }

    set endDate(strDate: string) {
        let val = this.parseDateLocal(strDate);
        const h = this.endDateInternal.getHours();
        const m = this.endDateInternal.getMinutes();
        const s = this.endDateInternal.getSeconds();
        val.setHours(h, m, s);
        this.endDateInternal = val;
    }

    public constructor(eventName: string, location: string, startDate: Date, endDate: Date, description: string, event: PubEvent | null, endDateEnabled: boolean, eType: EventType, canceled: boolean) {
        this.eventName = eventName;
        this.location = location;
        this.startDateInternal = startDate;
        this.endDateInternal = endDate;
        this.description = description;
        this.event = event;
        this.endDateEnabled = endDateEnabled;
        this.eType = eType;
        this.canceled = canceled;
    }

    public toJson(): string {
        return JSON.stringify({
            eventName: this.eventName,
            location: this.location,
            startDateInternal: this.startDateInternal,
            endDateInternal: this.endDateInternal,
            description: this.description,
            endDateEnabled: this.endDateEnabled,
            eType: this.eType,
            canceled: this.canceled,
        });
    }

    public fromJson(inputData: any) {
        this.eventName = inputData.eventName;
        this.location = inputData.location;
        this.startDateInternal = new Date(inputData.startDateInternal);
        this.endDateInternal = new Date(inputData.endDateInternal);
        this.description = inputData.description;
        this.endDateEnabled = inputData.endDateEnabled;
        this.eType = inputData.eType;
        this.canceled = inputData.canceled;
    }

    strtdatetime(): Number {
        return this.startDateInternal.valueOf();
    }
    enddatetime(): Number {
        return this.endDateInternal.valueOf();
    }

    parseDateLocal(dateString: string): Date {
        const [year, month, day] = dateString.split("-").map(Number);
        return new Date(year, month - 1, day);
    }

    dateToISOString(date: Date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        return `${year}-${formattedMonth}-${formattedDay}`;
    }

    toNewEventRequest(): NewEventFromUserRequest {
        if (!this.startDateInternal || isNaN(this.startDateInternal.getTime())) {
            throw new Error("Start date and time must be set");
        }

        return {
            name: this.eventName,
            description: this.description,
            location: this.location,
            time: this.strtdatetime() as number,
            endTime: this.endDateEnabled ? (this.enddatetime() as number) : undefined,
            type: this.eType,
        };
    }

    toUpdateEventRequest(): UpdateEventRequest {
        if (!this.event) {
            throw new Error("Cannot create UpdateEventRequest without an event");
        }
        return {
            eventId: this.event.id,
            name: this.eventName,
            description: this.description,
            location: this.location,
            time: this.strtdatetime() as number,
            endTime: this.endDateEnabled ? (this.enddatetime() as number) : undefined,
            type: this.eType,
            cancel: this.canceled,
        };
    }
}
